// fe-link-wheel-white-block-icon-overflow-r2 (staging port of dev PR#5397) —
// the single source of truth for the square slot a Link Wheel browse row
// reserves for its wheel icon. The row card is this slot + the card's 8px
// padding + its 1px border (= 88px tall, measured live on web-stg).
// WheelComponent always renders 1:1, so the icon's WIDTH is what sets its
// height: a width-only box wider than this slot bleeds out of the card and
// lands its white backing disc on the rows above and below (rows are only
// 8px apart). Keep width === height === this value.
export const WHEEL_ICON_SLOT = "70px";

export const styles = {
  wheelContainer: {
    width: WHEEL_ICON_SLOT,
    height: WHEEL_ICON_SLOT,
    // Defence in depth: even if a future WheelComponent change re-grows the
    // inner SVG, it can no longer paint over the neighbouring rows.
    overflow: "hidden",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    flexShrink: 0,
  },

  searchTextField: {
    width: "100%",
    "& .MuiOutlinedInput-root": {
      "&.Mui-focused fieldset": {},
    },
  },

  searchInput: {
    borderRadius: "4px",
    backgroundColor: "#F6F7F9",
    color: "#565556",
    height: "40px",
  },

  dropdownStyle: {
    width: "80px",
    height: "40px",
    borderRadius: "4px",
    border: "1px solid #123051",

    "& > fieldset": {
      border: "none",
    },
  },

  wheelComponentContainer: {
    height: "32px",
    width: "32px",
  },

  iconStyles: {
    height: "16px",
    width: "16px",
  },
};
